// extracted by mini-css-extract-plugin
export default {"results-container":"TableFilter-module__results-container__bwFfN","resultsContainer":"TableFilter-module__results-container__bwFfN"};